import breakpoints from "../../sass/_export_to_js.module.scss";

(function ($) {
  "use strict";
  Drupal.behaviors.jqueryPassiveScroll = {
    attach: function (context, settings) {
      jQuery.event.special.touchstart = {
        setup: function (_, ns, handle) {
          this.addEventListener("touchstart", handle, {
            passive: !ns.includes("noPreventDefault"),
          });
        },
      };
      jQuery.event.special.touchmove = {
        setup: function (_, ns, handle) {
          this.addEventListener("touchmove", handle, {
            passive: !ns.includes("noPreventDefault"),
          });
        },
      };
      jQuery.event.special.wheel = {
        setup: function (_, ns, handle) {
          this.addEventListener("wheel", handle, { passive: true });
        },
      };
      jQuery.event.special.mousewheel = {
        setup: function (_, ns, handle) {
          this.addEventListener("mousewheel", handle, { passive: true });
        },
      };
    },
  };

  Drupal.behaviors.iosVideos = {
    attach: function (context, settings) {
      if (Drupal.isIos()) {
        window.setInterval(function () {
          let $vidz = $("video.b-loaded:not(.reload-done)");
          $vidz.each(function () {
            $(this)[0].load();
            $(this).addClass("reload-done");
          });
        }, 250);
      }
    },
  };

  Drupal.decodeHtml = function (html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  Drupal.behaviors.videoResponsive = {
    attach: function (context, settings) {
      const $responsiveVidz = $(
        once("onced-videoResponsive", ".responsive-video", context)
      );

      function loadVideoSrc($video, srcElement) {
        if (srcElement.attr("src") === "") {
          srcElement.attr("src", srcElement.data("src"));
        }
        $video[0].load();
      }
      function switchResponsivVidzSrc() {
        $responsiveVidz.each(function () {
          let $sources = $(this).find("source");
          let $video = $(this).find("video");
          let $unmatchedSources = $(this).find(".unmatchedsources");
          $sources.each(function () {
            if (
              "matchMedia" in window &&
              window.matchMedia("" + $(this).attr("media")).matches
            ) {
              if ($(this).parent(".unmatchedsources").length) {
                $(this).detach().appendTo($video);
                if ($video.hasClass("b-loaded")) {
                  loadVideoSrc($video, $(this));
                }
              }
            } else {
              if ($(this).parent("video").length) {
                $(this).detach().appendTo($unmatchedSources);
              }
            }
          });
        });
      }
      $responsiveVidz.each(function () {
        $(this).append('<div class="unmatchedsources"></div>');
      });
      switchResponsivVidzSrc();
      window.addEventListener("resize", switchResponsivVidzSrc, false);
    },
  };

  Drupal.behaviors.noScrollbar100vw = {
    attach: function (context, settings) {
      function _calculateScrollbarWidth() {
        document.documentElement.style.setProperty(
          "--scrollbar-width",
          window.innerWidth - document.documentElement.clientWidth + "px"
        );
      }
      window.addEventListener("resize", _calculateScrollbarWidth, false);
      document.addEventListener(
        "DOMContentLoaded",
        _calculateScrollbarWidth,
        false
      );
      window.addEventListener("load", _calculateScrollbarWidth);
    },
  };

  Drupal.behaviors.setMobileReadyVh = {
    attach: function (context, settings) {
      const appHeight = () => {
        const doc = document.documentElement;
        doc.style.setProperty("--vh", `${window.innerHeight}px`);
      };
      window.addEventListener("resize", appHeight);
      appHeight();
    },
  };

  Drupal.behaviors.accordionProductDetails = {
    attach: function (context, settings) {
      // Accordeonize the product details
      let anchor = Drupal.extractAnchor(window.location.href);
      if (anchor) {
        Drupal.scrollToElement("#" + anchor, $("header"));
      }
    },
  };
  // generate breakpoint function from mmaw.breakpoints.yml$
  for (let breakpointKey in breakpoints) {
    Drupal["is_" + breakpointKey] = function () {
      if (
        "matchMedia" in window &&
        !window.matchMedia("" + breakpoints[breakpointKey]).matches
      ) {
        return false;
      } else {
        return true;
      }
    };
  }

  Drupal.isElementInViewport = (el) => {
    // Special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
      el = el[0];
    }

    var rect = el.getBoundingClientRect();
    // offsetParent test for visibility for non position fixed element
    return (
      el.offsetParent !== null &&
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight ||
          document.documentElement.clientHeight) /* or $(window).height() */ &&
      rect.right <=
        (window.innerWidth ||
          document.documentElement.clientWidth) /* or $(window).width() */
    );
  };

  Drupal.hexToRgbA = function (hex, alpha = 1) {
    const [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16));
    return `rgba(${r},${g},${b},${alpha})`;
  };

  Drupal.toggleModal = ($modal, $veil = $(".veil.full")) => {
    const $body = $("body");
    const modalOpenClass = "popin-opened";
    const $header = $(".wpage > header");
    if ($modal.is(":hidden")) {
      $modal.css("display", "flex");
    }
    if (Drupal.is_tabletsDown() && !$body.hasClass(modalOpenClass)) {
      // When the modal WILL be shown
      $body.data("scrollY", window.scrollY);
    }
    setTimeout(() => {
      $modal.toggleClass("opened");
      $header.toggleClass("pop-in-opened");
      $body.toggleClass(modalOpenClass);
      $veil.stop().fadeToggle(function (e) {
        if (!$modal.hasClass("opened")) {
          $modal.hide();
        }
      });
      if (Drupal.is_tabletsDown() && !$body.hasClass(modalOpenClass)) {
        // When the modal IS hidden...
        let scroll = $body.data("scrollY") || 0;
        window.scrollTo(0, scroll);
      }
      if (typeof Drupal.blazy !== undefined) Drupal.blazy.init.revalidate();
    }, 1);
  };

  Drupal.isIos = function () {
    return (
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform) ||
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
  };

  Drupal.extractAnchor = function (url) {
    let anchorIndex = url.indexOf("#");
    if (anchorIndex !== -1) {
      return url.substring(anchorIndex + 1);
    }
  };

  Drupal.hasQueryString = function (name, value) {
    if (typeof value === "undefined") {
      value = "";
    }

    let regex = new RegExp("[?&]" + name + "=" + value);
    return regex.test(location.search); // location.search = querystring part of the url
  };

  Drupal.untabify = function (Links) {
    Links.each(function () {
      let target = $($(this).attr("href"));
      target.show();
    });
    Links.off("click");
  };

  //see scss mixin of same name in vendor/mmaw/_mixins.scss
  //tab link needs to be a "a" link with the tabsContents's css selector in href
  Drupal.tabify = function (Links, displayFirstTabIfNoActiveTab) {
    if (typeof variable === "undefined") {
      displayFirstTabIfNoActiveTab = true;
    }

    let $targets = $(),
      activeTabExist = false;

    Links.each(function () {
      let $target = $($(this).attr("href"));
      $targets = $targets.add($target);
      if (!$target.hasClass("active")) {
        $target.hide();
      } else {
        activeTabExist = true;
      }
    });

    if (!activeTabExist && displayFirstTabIfNoActiveTab) {
      $targets.first().addClass("active");
      $targets.first().show();
      Links.first().addClass("active");
    }

    Links.click(function (e) {
      e.preventDefault();
      let $target = $($(this).attr("href"));
      Links.removeClass("active");
      $(this).addClass("active");
      $targets.removeClass("active");
      $targets.hide();
      $target.addClass("active").show();

      let $slick = $target.find(".slick-initialized");
      if ($slick.length > 0) {
        $slick.slick("reinit");
      }

      var $video = $target.find("video");

      if ($video.length > 0) {
        $video[0].play();
      }
      if (typeof Drupal.blazy !== undefined) Drupal.blazy.init.revalidate();
    });
  };

  function selectifier(e) {
    let $listWrapper = e.data.listWrapper;
    if (!$listWrapper.hasClass("open")) {
      $listWrapper.addClass("open");
      $(this).siblings().slideDown();
      if (typeof Drupal.blazy !== undefined) Drupal.blazy.init.revalidate();
      return false;
    } else {
      $listWrapper.removeClass("open");
      $(this).addClass(e.data.activeClass);
      $(this).siblings().removeClass(e.data.activeClass).slideUp();
    }
  }

  //see scss mixin of same name in vendor/mmaw/_mixins.scss
  Drupal.selectify = function ($listWrapper, activeClass) {
    if (typeof activeClass === "undefined") {
      activeClass = "active";
    }
    let $elements = $listWrapper.children();
    let $selectedElement = $elements.filter("." + activeClass);
    if ($selectedElement.length < 1) {
      $selectedElement = $elements.filter(":first-child");
    }
    $selectedElement.siblings().hide();
    $selectedElement.click(function () {
      return false;
    });
    if ($elements.length >= 1 && $listWrapper.length >= 1) {
      $elements.off("click", selectifier);
      $elements.on(
        "click",
        { listWrapper: $listWrapper, activeClass: activeClass },
        selectifier
      );
    }
  };

  Drupal.unSelectify = function ($listWrapper) {
    let $elements = $listWrapper.children();
    $elements.show();
    $elements.off("click", selectifier);
  };

  Drupal.unHorizontalScrollCounter = function ($listWrapper) {
    $listWrapper.parent().children(".counter").remove();
  };

  Drupal.horizontalScrollCounter = function ($listWrapper) {
    var $listeElements = $listWrapper.children();
    var originalPos = [];
    $listeElements.each(function () {
      originalPos.push($(this).position().left - $(this).width() / 2);
    });
    if (!$listWrapper.parent().children(".counter").length) {
      var $counter = $(
        '<div class="counter"><span class="number">1</span> / <span class="total">' +
          $listeElements.length +
          "</span></div>"
      );
      $counter.insertAfter($listWrapper);
      $listWrapper.on("scroll", function () {
        var i = 0;
        if (
          $listWrapper[0].scrollWidth - $listWrapper.scrollLeft() <=
          $listWrapper.outerWidth()
        ) {
          i = $listeElements.length;
        } else {
          originalPos.forEach(function (val) {
            if ($listWrapper.scrollLeft() >= val) {
              i++;
              if (typeof Drupal.blazy !== undefined) {
                Drupal.blazy.init.revalidate();
              }
              return false; // break each loop
            }
          });
        }
        if (i !== 0) {
          $counter.find(".number").text(i);
        }
      });
    }
  }; //see scss mixin of same name in vendor/mmaw/_mixins.scss

  //see scss mixin of same name in vendor/mmaw/_mixins.scss
  Drupal.accordeonize = function (element, targetToClick, targeToOpen) {
    targetToClick = element.find(targetToClick);
    targeToOpen = element.find(targeToOpen);
    targetToClick.click(function (e) {
      e.preventDefault();
      targeToOpen.stop().slideToggle(300, "linear", function () {
        if (targeToOpen.is(":visible")) {
          targeToOpen.css("height", "auto");
          if (typeof Drupal.blazy !== undefined) Drupal.blazy.init.revalidate();
        } else {
          targeToOpen.css("height", 0);
        }
      });
      element.toggleClass("opened");
    });
  };

  Drupal.scrollToElement = function (
    anchorSelector,
    $stickyMenu,
    $elementToFlash
  ) {
    let $aTag = $(anchorSelector);
    let topOffset = $aTag.offset().top;
    if (typeof $stickyMenu !== "undefined" && $stickyMenu.length > 0) {
      $stickyMenu.addClass("fixedonscroll");
      topOffset = topOffset - $stickyMenu.innerHeight();
    }
    $("html,body").animate({ scrollTop: topOffset }, 300, "swing", function () {
      if (
        typeof $elementToFlash !== "undefined" &&
        $elementToFlash.length > 0
      ) {
        Drupal.flashCssClass($elementToFlash);
      }
    });
  };

  Drupal.flashCssClass = function ($elementToFlash, cssClass = "flashing") {
    $elementToFlash.addClass(cssClass);
    window.setTimeout(function () {
      $elementToFlash.removeClass(cssClass);
    }, 200);
    window.setTimeout(function () {
      $elementToFlash.addClass(cssClass);
    }, 400);
    window.setTimeout(function () {
      $elementToFlash.removeClass(cssClass);
    }, 600);
  };

  //see scss mixin of same name in vendor/mmaw/_mixins.scss
  Drupal.fixedOnScroll = function (context, elementSelector) {
    // var $element = $(once("onced-fos", elementSelector, context));
    // if ($element.length) {
    //   let elementTopPosition = $element.offset().top;
    //   let $body = $("body");
    //   let bodyOriginalPaddingTop = parseInt($body.css("padding-top"));
    //   let elementOriginalPaddingTop = parseInt($element.css("padding-top"));
    //   let processFixing = function ($window) {
    //     if ($window.scrollTop() <= elementTopPosition) {
    //       $element.removeClass("fixedonscroll");
    //       $body.css("padding-top", bodyOriginalPaddingTop);
    //       $element.css("padding-top", elementOriginalPaddingTop);
    //       //reflow & repaint header for safari
    //       $element[0].style.display = "none";
    //       $element[0].offsetHeight; // no need to store this anywhere, the reference is enough
    //       $element[0].style.display = "";
    //     } else {
    //       $element.addClass("fixedonscroll");
    //       let $elementHeight =
    //         $element.css("position") === "absolute" ? $element.height() : 0;
    //       $body.css(
    //         "padding-top",
    //         Number($elementHeight) + bodyOriginalPaddingTop
    //       );
    //       $element.css(
    //         "padding-top",
    //         bodyOriginalPaddingTop + elementOriginalPaddingTop
    //       );
    //     }
    //   };
    //   $(window).on("scroll resize load", function () {
    //     processFixing($(this));
    //   });
    // }
  };

  Drupal.popIn = function (
    $element,
    behaviourWhenPopupOpen = function () {},
    behaviourWhenPopupClose = function () {}
  ) {
    var $element = $(once("onced-popIn", $element.attr("href"), context));
    $target.hide();
    let $modal = Drupal.dialog($target, {
      modal: true,
      open: function () {
        $target.show();
        $target.removeClass("closed");
        behaviourWhenPopupOpen($target);
      },
      beforeClose: function () {
        $target.hide();
        $target.addClass("closed");
        behaviourWhenPopupClose($target);
      },
    });
    $element.click(function (e) {
      e.preventDefault();
      $modal.showModal();
    });
  };

  Drupal.isEmail = function (email) {
    var regex =
      /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return regex.test(email);
  };

  Drupal.setCookie = function (name, value, days) {
    let expires = "";
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  };

  Drupal.getCookie = function (name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  };

  Drupal.eraseCookie = function (name) {
    document.cookie =
      name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  };

  Drupal.tabNavigationLimitedToElement = function (context) {
    const tabbableElements =
      "a[href], area[href], input:not([disabled])," +
      "select:not([disabled]), textarea:not([disabled])," +
      "button:not([disabled]), iframe, object, embed, *[tabindex]," +
      "*[contenteditable]";

    var allTabbableElements = context.querySelectorAll(tabbableElements);
    var firstTabbableElement = allTabbableElements[0];
    var lastTabbableElement =
      allTabbableElements[allTabbableElements.length - 1];

    var keyListener = function (event) {
      var keyCode = event.which || event.keyCode; // Get the current keycode

      // Polyfill to prevent the default behavior of events
      event.preventDefault =
        event.preventDefault ||
        function () {
          event.returnValue = false;
        };

      // If it is TAB
      if (keyCode === 9) {
        // Move focus to first element that can be tabbed if Shift isn't used
        if (event.target === lastTabbableElement && !event.shiftKey) {
          event.preventDefault();
          firstTabbableElement.focus();

          // Move focus to last element that can be tabbed if Shift is used
        } else if (event.target === firstTabbableElement && event.shiftKey) {
          event.preventDefault();
          lastTabbableElement.focus();
        }
      }
    };

    context.addEventListener("keydown", keyListener, false);
  };
})(jQuery, Drupal);
